import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const PropalIcon = props => {
    // tslint:disable
    return (
        <SvgRoot {...props}>
            <g fill="none" stroke={props.nativeColor} strokeLinecap="round" strokeLinejoin="round">
                <line x1="15.5" y1="17" x2="15.5" y2="22"/>
                <line x1="13" y1="19.5" x2="18" y2="19.5"/>
                <polyline points="13.5,23.5 3.5,23.5 3.5,0.5 20.5,0.5 20.5,19.5 "/>
                <line x1="6.5" y1="5.5" x2="16.5" y2="5.5"/>
                <line x1="6.5" y1="8.5" x2="16.5" y2="8.5"/>
                <line x1="6.5" y1="11.5" x2="16.5" y2="11.5"/>
                <line x1="6.5" y1="14.5" x2="11.5" y2="14.5"/>
            </g>
        </SvgRoot>
    );
}

export default PropalIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/PropalIcon.tsx